import React, { useEffect } from "react";
import img1 from "../../../Assets/propertydetails/pg1.png";
import img2 from "../../../Assets/propertydetails/pg2.png";
import img3 from "../../../Assets/propertydetails/pg3.png";
import img4 from "../../../Assets/propertydetails/pg4.png";
import img5 from "../../../Assets/propertydetails/pg5.png";
import Aos from "aos";
import "aos/dist/aos.css";
const Banner = ({ building }) => {
  useEffect(() => {
    Aos.init({
      duration: 1000, // Animation duration
      easing: "ease-in-out", // Animation easing
      once: true, // Animation happens only once when scrolled into view
    });
  }, []);

  console.log("building: ", building);
  return (
    <div className="mx-0 sm:px-16 px-6 lg:mt-[107px] md:mt-[73px] mt-[70px]">
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
        <div className="w-full" data-aos="fade-right">
          <img
            src={building?.images[0] || ""}
            alt="Hostel Main"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>

        <div className="grid grid-cols-2 w-full gap-5">
          <img
            src={building?.images[1] || ""}
            alt="Room Images"
            className="w-full h-full object-cover rounded-lg"
            data-aos="zoom-in"
          />
          <img
            src={building?.images[2] || ""}
            alt="Room Images"
            className="w-full h-full object-cover rounded-lg"
            data-aos="zoom-in"
          />
          <img
            src={building?.images[3] || ""}
            alt="Room Images"
            className="w-full h-full object-cover rounded-lg"
            data-aos="zoom-in"
          />
          <img
            src={building?.images[4] || ""}
            alt="Room Images"
            className="w-full h-full object-cover rounded-lg"
            data-aos="zoom-in"
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
